import { Component } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }      from '../../api/api.service';
import { ConfirmService }  from '../../messages/confirm/confirm.service';
import { MessagesService } from '../../messages/messages.service';
import { GlobalDatePipe }  from '../../shared/pipes/global-date.pipe';

@Component({
  selector   : 'wor-print-jobs',
  template: require('./transaction-center.jobs.print.component.html')
})
export class PrintJobsComponent {
  date = '';
  isError = false;

  constructor (
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private confirmService: ConfirmService,
    private globalDatePipe: GlobalDatePipe,
    private messagesService: MessagesService,
    private translateService: TranslateService
  ) {}

  printJobsForDate (): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.PRINT_JOB_CARDS_FOR_DATE', {
      date: this.globalDatePipe.transform(this.date, 'longDate')
    }))
    .then(() => this.apiService.get('/invoices/get_jobs_for_today', this.globalDatePipe.transform(this.date, 'yyyy-MM-dd')))
    .then(response => {
      if (response.invoices.marine_invoices.length && !response.invoices.other_invoices.length) {
        return this.apiService.post('/reports/jasper_job_card_bulk', {
          invoice_id_string: response.invoice_id_string.marine,
          invoices         : response.invoices.marine_invoices,
          job_card_type    : 'marine'
        }, 'print', null, { responseType: 'arraybuffer' });
      }
      else if (response.invoices.other_invoices.length && !response.invoices.marine_invoices.length) {
        return this.apiService.post('/reports/jasper_job_card_bulk', {
          invoice_id_string: response.invoice_id_string.no_marine,
          invoices         : response.invoices.other_invoices,
          job_card_type    : 'default'
        }, 'print', null, { responseType: 'arraybuffer' });
      }

      return Promise.all([
        this.apiService.post('/reports/jasper_job_card_bulk', {
          invoice_id_string: response.invoice_id_string.marine,
          invoices         : response.invoices.marine_invoices,
          job_card_type    : 'marine'
        }, 'print', null, { responseType: 'arraybuffer' }),
        this.apiService.post('/reports/jasper_job_card_bulk', {
          invoice_id_string: response.invoice_id_string.no_marine,
          invoices         : response.invoices.other_invoices,
          job_card_type    : 'default'
        }, 'print', null, { responseType: 'arraybuffer' })
      ]);
    })
    .then(response => {
      const pdfs = Array.isArray(response) ? response : [response];

      pdfs.forEach(pdf => {
        if (!this.isError) {
          const file    = new Blob([pdf], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          const newWin  = window.open(fileURL, '_blank');

          if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {


            this.isError = true;


            this.messagesService.show(this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.POPUPS_BLOCKED'), 'error');


          }
        }
      });
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }
}
